export const strings = {
  NAME: "AI Generated",
  DESCRIPTION: "A component generated by AI",
  KEYWORDS: "ai generated component",
} as const;
